import React, { useEffect } from 'react';
import styles from './contentFooter.module.scss';
import { routes } from 'src/routes';
import googleIcon from './google_play_ico.svg';
import appstoreIcon from './appstore_ico.svg';
import { useDispatch, useSelector } from 'react-redux';
import { GlobalState } from 'src/logic/reducers';
import { userActions } from 'src/logic/user';

type ContentFooterProps = {
  menu?: {
    label: string;
    path: string;
  }[];
};

const contacts = [
  { id: 1, title: 'Zamówienie internetowe', email: 'on-line@pobudka.pl'},
  { id: 2, title: 'Sprzedaż w biurach', email: 'biuro@pobudka.pl'},
  { id: 3, title: 'Dystrybucja w punktach B2B', email: 'b2b@pobudka.pl'},
  { id: 4, title: 'Godziny pracy biura obsługi klienta',phoneNumber: ' +48 222 438 300', hours: 'Poniedziałek - Piątek 8:00 - 15:00', email: 'kontakt@pobudka.pl'},
]

const footerMenu = [
  { label: 'O nas', path: routes.aboutUs() },
  { label: 'Nasza oferta', path: routes.offer() },
  { label: 'Zasięg', path: routes.deliveryRange() },
  { label: 'Dostawa do biur', path: routes.deliveryToOffices() },
  { label: 'Kontakt', path: routes.contact() },
  { label: 'Regulamin', path: routes.terms() },
  { label: 'Polityka prywatności', path: routes.privacy() },
];

const ContentFooter = ({ menu }: ContentFooterProps) => {
  const dispatch = useDispatch();
  useEffect(() => { dispatch(userActions.loadDeviceType()) }, [dispatch]);
  const deviceType = useSelector((gs: GlobalState) => gs.user.deviceType);
  const promotionRulesLink = useSelector((gs: GlobalState) => gs.settings.PROMOTION_RULES_LINK);
  const promotionRulesName = useSelector((gs: GlobalState) => gs.settings.PROMOTION_RULES_NAME);

  return (
    <>
    <footer className={styles.contentFooter}>
      <div className={styles.wrapper}>
        <div className={styles.leftFooter}>

      <div className={styles.footerContact}>
        {contacts.map(contact => (
          <div
              key={contact.id}
              className={styles.contactElement}
          >
              <div className={styles.contactTitle}>{contact.title}</div>
              <div className={styles.contactContent}>
                  {contact.phoneNumber && (
                      <a
                          className={styles.contactPhone}
                          href={`tel:${contact.phoneNumber}`}
                      >
                          {contact.phoneNumber}
                      </a>
                  )}
                  {contact.email && (
                      <a
                          className={styles.contactEmail}
                          href={`mailto:${contact.email}`}
                      >
                          {contact.email}
                      </a>
                  )}
                    {contact.hours && (
                      <div
                          className={styles.contactEmail}
                      >
                          {contact.hours}
                      </div>
                  )}
              </div>
            </div>
          ))}
        </div>

        <nav className={styles.footerNav}>
          {menu ??
            footerMenu.map((menuItem, i) => (
              menuItem.path === routes.terms() && promotionRulesLink
              ? <div className={styles.footerDropdown}>
                <span className={styles.link}>Regulamin</span>
                <ul className={styles.footerDropdownMenu}>
                  <li>
                    <a className={styles.link} href={menuItem.path}>Regulamin strony</a>
                  </li>
                  {promotionRulesLink &&
                  <li>
                    <a className={styles.link} href={promotionRulesLink} target="_blank" rel="noopener noreferrer">{promotionRulesName || 'Regulamin promocji'}</a>
                  </li>}
                </ul>
              </div>
              : <a key={i} href={menuItem.path} className={styles.link}>
                <span>{menuItem.label}</span>
              </a>
            ))}
        </nav>
        </div>
        <img src="/images/footer-map.svg" alt="Pobudka" className={styles.logo} />
      </div>
          <div className={styles.media}>
            {(!deviceType || (deviceType !== 'ios')) && <a href={'https://play.google.com/store/apps/details?id=pl.waw.pobudka.twa'} rel='noopener noreferrer' target='_blank'>
              <img src={googleIcon} alt={'Pobierz aplikacje z Google Play'} />
            </a>}
            {(!deviceType || (deviceType === 'ios')) && <a href={'https://apps.apple.com/pl/app/pobudka/id1539031354'} rel='noopener noreferrer' target='_blank'>
              <img src={appstoreIcon} alt={'Pobierz aplikacje z Appstore'} height={42} />
            </a>}
          </div>
        <p>Pobudka &copy; 2020</p>
        {/* <p className={styles.footerMadeBy}>Made with ❤ by <a href="https://simplesoft.tech/" target="_blank" rel="noopener noreferrer">simplesoft.tech</a></p> */}
    </footer>
        <p className={styles.footerMadeBy}>Made with ❤ by <a href="https://simplesoft.tech/" target="_blank" rel="noopener noreferrer">simplesoft.tech</a></p>
        </>
  )
};
export default ContentFooter;
